// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_djU7-","parallax":"parallax_FfHAW","ahead":"ahead_qMDjc"};